import React from 'react';
import BaseInputAdornment from '@material-ui/core/InputAdornment';

const InputAdornment = (props) => <BaseInputAdornment {...props} />;

export default InputAdornment;
